export default "__VITE_ASSET__e4069e80__"